import { type ColumnDef } from "@tanstack/react-table";
import type { ChangeRequestDto } from "../../../../api";
import { TableTextCell } from "../../../../components/common/table/text-cell";
import { formatDate } from "../../../../utils/date";
import { ChangeRequestStatusBadge } from "./change-request-status-badge";
import { humanizeTypeForOwner } from "../../data/change-request-type";

export const changeRequestsColumns: ColumnDef<ChangeRequestDto>[] = [
  {
    accessorKey: "type",
    header: "Type",
    enableSorting: true,
    cell: ({ row }) => <TableTextCell value={humanizeTypeForOwner(row.original.type)} />,
  },
  {
    accessorKey: "status",
    header: "Status",
    enableSorting: true,
    cell: ({ row }) => <ChangeRequestStatusBadge status={row.original.status} />,
  },
  {
    accessorKey: "submittedAt",
    header: "Submitted",
    enableSorting: true,
    cell: ({ row }) => (
      <TableTextCell
        value={row.original.submittedAt ? formatDate(row.original.submittedAt, true) : "—"}
      />
    ),
  },
  {
    accessorKey: "updatedAt",
    header: "Last updated",
    enableSorting: true,
    cell: ({ row }) => (
      <TableTextCell value={formatDate(row.original.updatedAt, true)} />
    ),
  },
];
